//
import Model from '@/models/Model'

//
import AuthorizeModel from '@/models/Actions/AAuthorize'
import PreviredModel from '@/models/Actions/APrevired'

/**
 * @class
 */
export default class HrPayroll extends Model {
    //
    static appends = ['has_generated_previred_format']

    //
    static includes = [
        'g_user.hr_employee',
        'g_authorizer_user.hr_employee',
        'hr_detail_payrolls.hr_salary_settlement.hr_employee',
        'hr_detail_payrolls.hr_salary_settlement.hr_contract',
        'hr_detail_payrolls.hr_salary_settlement.hr_prevision',
        'hr_detail_payrolls.hr_salary_settlement.hr_health_affiliation',
        'hr_detail_payrolls.hr_salary_settlement.hr_indicator',
    ]

    //
    selected = []

    /**
     *
     */
    get can_authorize() {
        return !this.authorized
    }

    /**
     *
     */
    get can_download() {
        return this.has_generated_previred_format
    }

    /**
     *
     */
    get can_edit() {
        return this.can_authorize
    }

    /**
     *
     */
    get payment_period_month() {
        return this.payment_period ? this.payment_period.split('-').pop() : ''
    }

    /**
     *
     */
    get payment_period_year() {
        return this.payment_period ? this.payment_period.split('-').shift() : ''
    }

    /**
     *
     */
    authorize() {
        return this.hasMany(AuthorizeModel)
    }

    /**
     *
     */
    mapDetail = item => item.id

    /**
     *
     */
    mapSelected = item => ({
        ...item,
        ...item.hr_salary_settlement,
    })

    /**
     *
     */
    previred() {
        return this.hasMany(PreviredModel)
    }

    /**
     *
     */
    reset() {
        //
        this.payment_period = this.period_year + '-' + this.period_month
        this.selected = this.hr_detail_payrolls.map(this.mapSelected)
        //
        return this
    }

    /**
     *
     */
    resource() {
        return 'hr_payroll'
    }

    /**
     *
     */
    toCreate() {
        //
        this.details = this.selected.map(this.mapDetail)
        //
        this.period_month = Number(this.payment_period_month)
        this.period_year = Number(this.payment_period_year)
        //
        return this.clean([
            'details',
            'payment_date',
            'period_month',
            'period_year',
        ])
    }

    /**
     *
     */
    toExcel() {
        return this.excel('excel').then(this.showFile('Nomina de sueldo - ' + this.id, 'xlsx'))
    }

    /**
     *
     */
    toPreviredExcel() {
        return this.excel('previred_csv').then(this.showFile('previred', 'csv'))
    }

    /**
     *
     */
    toUpdate() {
        //
        this.details = this.selected.map(this.mapDetail)
        //
        this.period_month = Number(this.payment_period_month)
        this.period_year = Number(this.payment_period_year)
        //
        return this.clean([
            'details',
            'id',
            'payment_date',
            'period_month',
            'period_year',
        ])
    }
}
